import Keycloak from "keycloak-js";
import moment from "moment-timezone";

const keycloakConfig = {
  url: process.env.REACT_APP_KEYCLOAK_URL,
  realm: process.env.REACT_APP_KEYCLOAK_REALM,
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
};

let keycloakInstance = null;
let isInitialized = false; // Flag to check initialization
let isInitializing = false; // Flag to prevent multiple initialization calls

const KeycloakManager = (() => {
  // Only create the Keycloak instance once
  if (!keycloakInstance) {
    keycloakInstance = new Keycloak(keycloakConfig);
  }

  const initialize = async () => {
    if (isInitializing) {
    
      return { isLogin: false, token: null, loading: true }; // Return loading state if already initializing
    }

    // Prevent initialization if it's already initialized
    if (isInitialized) {
 
      return { isLogin: false, token: null, loading: false }; // Return current state if initialized
    }


    let isLogin = false;
    let token = null;
    let loading = true;

    try {
      isInitializing = true; // Mark initialization as in progress
      const authenticated = await keycloakInstance.init({
        onLoad: "login-required",
        checkLoginIframe: false,
        silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
        pkceMethod: 'S256',
        token: localStorage.getItem('token')?.replace('Bearer ', ''),
        refreshToken: localStorage.getItem('refreshToken'),
      });

      // Set up token refresh
      keycloakInstance.onTokenExpired = () => {

        keycloakInstance.updateToken(30).catch(() => {
       
          logout();
        });
      };

      if (authenticated) {
        isLogin = true;
        token = keycloakInstance.token;
        // Store tokens and expiry in localStorage
        localStorage.setItem("token", `Bearer ${keycloakInstance.token}`);
        localStorage.setItem("refreshToken", `${keycloakInstance.refreshToken}`);
        localStorage.setItem("keycloakSessionId", keycloakInstance.sessionId);

        const accessTokenExpiry = moment(
          keycloakInstance?.tokenParsed?.exp * 1000
        )
          .tz("Asia/Kolkata")
          .format("YYYY-MM-DD HH:mm:ss");

        localStorage.setItem("accessTokenExpiry", accessTokenExpiry);

        // Attach storage event listener to handle manual localStorage clearing
        setupLocalStorageListener();
      } else {
        console.error("Authentication failed");
      }
    } catch (err) {
      console.error("Failed to initialize Keycloak:", err);
    } finally {
      isInitializing = false; // Mark initialization as complete
      isInitialized = true; // Mark Keycloak as initialized
      loading = false;
    }

 
    return { isLogin, token, loading };
  };

  const logout = () => {
    if (keycloakInstance) {
      keycloakInstance
        .logout()
        .then(() => {
          localStorage.clear();
          isInitialized = false; // Reset initialization flag on logout
        })
        .catch((err) => {
          console.error("Logout failed:", err);
          localStorage.clear();
          isInitialized = false;
        });
    } else {
      console.error("Keycloak instance is not initialized");
      localStorage.clear();
      isInitialized = false;
    }
  };

  const handleManualLogout = () => {
    console.warn("Detected manual localStorage clearing. Logging out...");
    logout();
  };

  const setupLocalStorageListener = () => {
    window.addEventListener("storage", (event) => {
      if (event.key === null || event.key === "token") {
        // If localStorage is cleared or token is removed, trigger logout
        if (!localStorage.getItem("token")) {
          handleManualLogout();
        }
      }
    });
  };

  return { initialize, logout };
})();

export default KeycloakManager;